module.exports = __webpack_public_path__ + "static/media/2s.fbd8ee69.jpg";